module.exports = __webpack_public_path__ + "img/wxp.70189dff.webp";